module.exports = __webpack_public_path__ + "img/net_des_4.a6898d64.jpg";